import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { toggleFavorites } from "../../actions/favorites";
import Card from "../Card/index";
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 0.1fr;
  grid-template-rows: 1fr;
  grid-column-gap: 15px;
  position: relative;
  grid-template-areas: "box1 box1 box1 box2 box2";
  @media (max-width: 768px) {
    grid-template-columns: 1fr 1fr 0.5fr 1fr 1fr;
    grid-column-gap: 12px;
    margin-left: -20px;
    grid-template-areas: "box1 box1 box1  box2 box2";
  }
  h3 {
    margin-top: 70px !important;
    @media (max-width: 768px) {
      margin-top: 0px !important;
    }
  }
  .wrapper {
    display: -webkit-flex;
    flex-direction: column;
    gap: 15px;
    grid-area: box2;
    @media (max-width: 768px) {
      gap: 12px;
    }
  }
  [class^="box"] {
    position: relative;
    width: 15rem !important;
    @media (max-width: 768px) {
      width: 162px !important;
    }
  }
  .box {
    &-1,
    &-2,
    &-3 {
      ${(props) =>
        props.addcircuit
          ? `.hover-box {
          position: absolute;
          height: 100% !important;
          width: 100% !important;
          background: ${({ theme }) => theme.black};
          z-index: 9999999;
          object-fit: cover;
          > * > * {
            color: ${({ theme }) => theme.white};
          }
          .info {
            text-align: center;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            img {
              cursor: pointer;
            }
          }
          .img {
            width: 100%;
            height: 100%;
            position: absolute;
          }
        }`
          : `.hover-box {display: none}`}
    }
    &-1 {
      width: 100% !important;
      height: 775px;
      grid-area: box1;
    }
    &-2,
    &-3 {
      width: 100% !important;
      height: 380px;
    }
    @media (max-width: 768px) {
      &-1 {
        height: 336px;
      }
      &-2,
      &-3 {
        height: 162px;
      }
    }
  }
  .hover-box {
    position: absolute;
    height: 0%;
    width: 0px;
    transition: all 0.4s;
  }
`;
function ImageGrid({ addcircuit, slide, local, getSafe }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const handleFavorite = (fav, checked) => {
    dispatch(toggleFavorites({ circuits: [fav] }));
  };

  return (
    <Grid addcircuit={addcircuit}>
      {slide[0] && (
        <div className="box-1">
          <Card.Header
            id={getSafe(() => slide[0]._id)}
            handleFav={handleFavorite}
            circuit
          />
          <Card.ResponsiveImg
            src={getSafe(() => slide[0].media[0].url)}
            onClick={() => history.push(`/${local}/circuit/${slide[0]._id}`)}
            alt={getSafe(() => slide[0].title[local], "")}
          />
          <Card.Body
            onClick={() => history.push(`/${local}/circuit/${slide[0]._id}`)}
          >
            <Card.Title grid>
              {getSafe(() => slide[0]["title"][local])}
            </Card.Title>
          </Card.Body>
        </div>
      )}
      <div className="wrapper">
        {slide[1] && (
          <div className="box-2">
            {/* <div className="hover-box">
              <div
                className="info"
                onClick={() => history.push(`/${local}/plan`)}
              >
                <img src={plus} alt="plus" />
                <H1>{t("circuit")}</H1>
              </div>
            </div> */}
            <Card.Header
              id={getSafe(() => slide[1]._id)}
              handleFav={handleFavorite}
              circuit
            />
            <Card.ResponsiveImg
              src={getSafe(() => slide[1].media[0].url)}
              onClick={() => history.push(`/${local}/circuit/${slide[1]._id}`)}
              alt={getSafe(() => slide[1].title[local], "")}
            />
            <Card.Body
              onClick={() => history.push(`/${local}/circuit/${slide[1]._id}`)}
            >
              <Card.Title grid>
                {getSafe(() => slide[1]["title"][local])}
              </Card.Title>
            </Card.Body>
          </div>
        )}
        {slide[2] && (
          <div className="box-3">
            <Card.Header
              id={getSafe(() => slide[2]._id)}
              handleFav={handleFavorite}
              circuit
            />
            <Card.ResponsiveImg
              src={getSafe(() => slide[2].media[0].url)}
              onClick={() => history.push(`/${local}/circuit/${slide[2]._id}`)}
              alt={getSafe(() => slide[2].title[local], "")}
            />
            <Card.Body
              onClick={() => history.push(`/${local}/circuit/${slide[2]._id}`)}
            >
              <Card.Title grid>
                {getSafe(() => slide[2]["title"][local])}
              </Card.Title>
            </Card.Body>
          </div>
        )}
      </div>
    </Grid>
  );
}

export default ImageGrid;
